import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layouts from './components/layouts/Layouts';
import HomePage from './pages/HomePages';
import AboutPage from './pages/AboutPages';
import ServicesPage from './pages/ServicesPages';
import ContactPage from './pages/ContactPages';
import PricingPage from './pages/PricingPages';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import DocsPage from './pages/DocsPage';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layouts />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/hakkimizda" element={<AboutPage />} />
          <Route path="/hizmetler" element={<ServicesPage />} />
          <Route path="/fiyatlandirma" element={<PricingPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/dokumantasyon" element={<Navigate to="/dokumantasyon/baslangic" replace />} />
          <Route path="/dokumantasyon/*" element={<DocsPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
